let initialState = {
  isVisible: false,
  component: {},
  parameters: {}
};

export default {
  state: () => initialState,
  mutations: {
    OPEN_MODAL(state, { component, parameters }) {
      state.isVisible = true;
      state.component = component;
      state.parameters = parameters;
    },
    CLOSE_MODAL(state) {
      state.isVisible = false;
      state.component = null;
      state.parameters = {};
    },
    RESET_MODALS(state) {
      const s = initialState
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    }
  },
  actions: {
    openModal({ commit }, { component, parameters = {} }) {
      commit('OPEN_MODAL', { component, parameters });
    },
    closeModal({ commit }) {
      commit('CLOSE_MODAL');
    },
    resetModals({ commit }) {
      commit('RESET_MODALS');
    }
  },
  getters: {
    isVisible: state => state?.isVisible,
    component: state => state?.component,
    parameters: state => state?.parameters
  }
};
